import { useEffect } from "react";

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || window.location.origin;

// Per-page SEO: title, meta description, canonical, and JSON-LD injection.
export const Seo = ({ title, description, path = "/", jsonLd = [] }) => {
  useEffect(() => {
    document.title = title;

    const setMeta = (key, content, attr = "name") => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", SITE_URL + path, "property");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", SITE_URL + path);

    const scripts = jsonLd.map((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
  }, [title, description, path, jsonLd]);

  return null;
};
